<template>
  <div class="auth-page">
    <div class="auth-card">
      <router-link :to="{ name: 'home' }" class="auth-logo" aria-label="Guiders home">
        <img src="../../assets/logo-circle.svg" alt="" />
      </router-link>

      <h1 class="auth-title">{{ title }}</h1>
      <p v-if="subtitle" class="auth-subtitle">{{ subtitle }}</p>

      <!-- One clear message, right where the person is looking -->
      <div v-if="error" class="auth-message is-error" role="alert">{{ error }}</div>
      <div v-if="success" class="auth-message is-success" role="status">{{ success }}</div>

      <slot />
    </div>

    <p v-if="$slots.footer" class="auth-footer">
      <slot name="footer" />
    </p>
  </div>
</template>

<script>
// Shared frame for the login, registration, forgot-password and email-link
// pages, so they all look and behave the same
export default {
  name: "AuthCard",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    error: { type: String, default: "" },
    success: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
$forest: #14342b;
$forest-2: #2c6e57;
$ink-sub: #4b5f57;
$line: #e1e8e3;
$soft: #f2f6f2;

.auth-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 0 3rem;
}

.auth-card {
  width: 100%;
  max-width: 28rem;
  padding: 2rem 2rem 1.75rem;
  background: #ffffff;
  border: 1px solid $line;
  border-radius: 18px;
}

.auth-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 1.25rem;

  img {
    height: 3.5rem;
    width: auto;
  }
}

.auth-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: $forest;
}

.auth-subtitle {
  margin-top: 0.5rem;
  text-align: center;
  color: $ink-sub;
  line-height: 1.5;
}

.auth-message {
  margin-top: 1.25rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.9375rem;
  line-height: 1.5;

  &.is-error {
    background: #fdecec;
    color: #8a1c1c;
    border: 1px solid #f5c2c2;
  }

  &.is-success {
    background: #f6fadf;
    color: $forest;
    border: 1px solid #c6e35a;
  }
}

.auth-footer {
  margin-top: 1.25rem;
  text-align: center;
  font-size: 0.9375rem;
  color: $ink-sub;

  ::v-deep a {
    font-weight: 500;
    color: $forest-2;
    text-decoration: underline;
  }
}

@media (max-width: 600px) {
  .auth-page {
    padding-top: 0.5rem;
  }

  .auth-card {
    padding: 1.5rem 1.25rem;
    border: 0;
  }
}
</style>
